<script>
import { Line as InfluencerTransitionGraph } from "vue-chartjs";

export default {
  extends: InfluencerTransitionGraph,
  props: {
    width: {
      type: String,
      default: "840",
    },
    height: {
      type: String,
      default: "340",
    },
    graph_data: {
      type: Object,
      default: null,
    },
    reRender: {
      type: Number,
      default: 0,
    },
    sns_type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    datas() {
      return {
        labels: this.graph_data.labels,
        datasets: [
          {
            type: "bar",
            label: "増減数",
            borderColor: "#427eff55",
            backgroundColor: "#427eff55",
            barThickness: 10,
            data: this.graph_data.increase,
            yAxisID: "transparent",
          },
          {
            label: this.sns_type == "instagram" ? "フォロワー数" : this.sns_type == "youtube" ? "チャンネル登録者数" : this.sns_type == "youtube_view" ? "総視聴回数" : this.sns_type == "youtube_median" ? "視聴回数中央値" : "",
            borderColor: "#0095f6",
            backgroundColor: "",
            borderWidth: 2,
            data: this.graph_data.data,
            pointRadius: 5,
            pointBackgroundColor: "#0095f6",
            yAxisID: "left",
          },
        ],
      };
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.handleChartClick,
        tooltips: {
          mode: "index",
          position: "nearest",
          intersect: false,
          titleMarginBottom: 10,
          xPadding: 10,
          yPadding: 10,
          bodySpacing: 10,
          callbacks: {
            label: function(tooltipItem) {
              return tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
          },
        },
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 0,
            bottom: 0,
          },
        },
        legend: {
          display: true,
          position: "top",
          align: "end",
          labels: {
            padding: 10,
            fontSize: 10,
            boxWidth: 20,
          },
        },
        scales: {
          xAxes: [
            {
              //x軸設定
              display: true, //表示設定
              ticks: {
                padding: 5,
                fontColor: "#aaa",
              },
              gridLines: {
                // このオプションを追加
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              id: "left", // Y軸のID
              type: "linear", // linear固定
              position: "left", // どちら側に表示される軸か？
              ticks: {
                padding: 5,
                fontColor: "#aaa",
                callback: function(label) {
                  return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                },
                // min: this.graph_data.minmax.followers_min,
                // max: this.graph_data.minmax.followers_max,
              },
            },
            {
              id: "transparent",
              type: "linear",
              position: "right",
              gridLines: {
                // このオプションを追加
                drawOnChartArea: true,
                color: "rgba(0,0,0,0)",
                zeroLineWidth: 1,
              },
              ticks: {
                padding: 5,
                fontColor: "#aaa",
                min: this.graph_data.minmax.increase_min,
                max: this.graph_data.minmax.increase_max,
                callback: function(label) {
                  return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                },
              },
            },
          ],
        },
      };
    },
  },
  mounted() {
    this.graphColor();
    this.renderChart(this.datas, this.options);
  },
  methods: {
    graphColor() {
      var gradient = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 300);
      gradient.addColorStop(0, "#0095f699");
      gradient.addColorStop(1, "#54ccdb11");
      this.datas.datasets[1].backgroundColor = gradient;
    },
    handleChartClick(event, elements) {
      if (elements.length) {
        // クリックされたら投稿タブを表示し、選択要素の日付〜前回更新日の日付の投稿を表示する
        const datasetIndex = elements[0]._index;
        const searchPeriodFrom = datasetIndex > 0 ? this.convertDateFormat(this.graph_data.labels[datasetIndex-1]) : "";
        const searchPeriodTo = this.convertDateFormat(this.graph_data.labels[datasetIndex]);
        this.$emit("update-data", "post", searchPeriodFrom, searchPeriodTo);
      }
    },
    convertDateFormat(dateString) {
      const [year, month, day] = dateString.split("/"); // "/"で分割
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  },
  watch: {
    datas() {
      this.graphColor();
      this.renderChart(this.datas, this.options);
    },
    reRender() {
      this.graphColor();
      this.renderChart(this.datas, this.options);
    },
  },
};
</script>
